import styled, { css } from "styled-components";
import { H4, IconButton, transition } from "@evergis/ui";
import { MapControl } from "@evergis/react";

import { Alias } from "../../../LayerList/styled";
import { LEFT_PANEL_MIN_WIDTH } from "../../../../components/Layout/constants";

export const BasemapListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 24rem;
  max-height: calc(50vh - 4rem);
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  position: inherit;
  bottom: 2rem;
  left: -2.25rem;
  background: ${({ theme: { palette } }) => palette.panelBackground};
  backdrop-filter: blur(10px);
`;

export const BasemapListBlock = styled.div`
  width: 22rem;
  max-height: calc(100% - 5rem);
  margin-top: 3.5rem;
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
  padding: 0 0.5rem 1.5rem 1.5rem;
`;

export const BasemapListTitle = styled.div`
  width: ${`${LEFT_PANEL_MIN_WIDTH}px`};
  height: 3.5rem;
  padding-left: 1.5rem;
  display: flex;
  position: fixed;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
`;

export const BasemapActions = styled.div`
  display: flex;
  align-items: center;
  height: 2rem;
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  opacity: 0.8;
  background-color: ${({ theme: { palette } }) => palette.elementDarkNoAlpha};
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  visibility: hidden;
`;

export const BasemapContainer = styled.div<{ selected: boolean }>`
  width: 10rem;
  height: 7.625rem;
  position: relative;
  display: flex;
  flex-direction: column;
  opacity: ${({ selected }) => (selected ? "1" : "0.6")};
  transition: opacity ${transition.hover};

  :hover {
    opacity: 1;

    ${BasemapActions} {
      visibility: visible;
    }
  }

  &:nth-of-type(odd) {
    margin-right: 1rem;
  }
`;

export const BasemapNameBlock = styled.div`
  width: 100%;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BasemapTitle = styled(H4)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

type ImageFallbackContainerProps = {
  color?: string;
  fallback?: string;
  selected?: boolean;
};

export const ImageFallbackContainer = styled.div<ImageFallbackContainerProps>`
  width: 100%;
  cursor: pointer;
  height: 5.625rem;

  background-image: ${({ fallback, color }) => (color ? "none" : `url(${fallback})`)};
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;

  border: 2px solid ${({ selected }) => (selected ? "#00AAFF" : "transparent")};
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};

  ${({ color }) =>
    color &&
    css`
      background-color: ${color};
    `}
`;
export const FallbackImage = styled.div`
  width: inherit;
  height: inherit;

  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: ${({ src }: { src: string }) => `url(${src})`};
`;

export const LegendButton = styled(IconButton)``;
LegendButton.defaultProps = {
  kind: "layers",
};

export const MapLegendContainer = styled(BasemapListContainer)<{
  geometrySelection?: boolean;
  bottomHeight?: number;
}>`
  width: 18.5rem;
  max-height: calc(
    100vh - 6.75rem - ${({ geometrySelection }) => (geometrySelection ? 3.25 : 0)}rem -
      ${({ bottomHeight }) => bottomHeight || 0}px
  );
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  overflow-y: auto;
  scrollbar-gutter: stable;
  transition: margin-left ${transition.collapse};

  ${MapControl} {
    &&& {
      background: transparent;
    }
  }

  ${Alias} {
    font-size: 0.875rem;
  }
`;
